// src/components/layout/Navbar.jsx
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../../services/supabase";

export default function Navbar() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Check session on mount and listen for auth changes
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setUser(data.session?.user || null);
    });

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user || null);
      }
    );

    return () => listener.subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login"); // redirect after logout
  };

  return (
    <nav className="bg-white border-bottom">
      <div className="container d-flex justify-content-between align-items-center py-2">
        {/* Left-side navigation */}
        <ul className="nav" style={{ borderBottom: "none" }}>
          <li className="nav-item">
            <Link className="nav-link" to="/">
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about">
              About Us
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/education">
              Education
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/gallery">
              Gallery
            </Link>
          </li>
          <li className="nav-item">
            <a className="nav-link"
              href="https://docs.google.com/forms/d/e/1FAIpQLSdYCsphoYTfXxz58QW-JSt-XKlgYS6gwM1cs9YkVOKO5lul3w/viewform?usp=sharing&amp;ouid=102691941283744599946"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => {
                e.preventDefault();
                if (window.confirm("You are being taken to an external site. Continue?")) {
                  window.open(e.currentTarget.href, "_blank", "noreferrer");
                }
              }}>
              Contact
            </a>
          </li>
        </ul>

        {/* Right-side auth buttons */}
        <div className="d-flex gap-2 align-items-center">
          {!user ? (
            <>
              <Link className="btn btn-outline-primary" to="/login">
                Log In
              </Link>
              <Link className="btn btn-primary" to="/signup">
                Sign Up
              </Link>
            </>
          ) : (
            <>
              <span className="me-2 text-muted">{user.email}</span>
              <button className="btn btn-outline-primary" onClick={handleLogout}>
                Log Out
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}